module.exports = __webpack_public_path__ + "img/continue.4913b1dc.gif";